import React, { useState } from 'react'
import { Avatar } from 'antd'

import { RequestTicketReceiptImage } from 'src/types'

import ThumbnailPreview from '../ThumbnailPreview'

import { ContainerImage, WrapRow } from './styles'

interface Props {
  images: RequestTicketReceiptImage[]
}

function ThumbnailList({ images }: Props) {
  const [preview, setPreview] = useState<string>()

  return (
    <>
      <WrapRow align="middle" gutter={24} type="flex">
        {images.map(item => (
          <ContainerImage
            key={item.request_ticket_receipt_image_id}
            onClick={() => setPreview(item.image_url)}
          >
            <Avatar shape="square" size={86} src={item.image_url} />
          </ContainerImage>
        ))}
      </WrapRow>
      <ThumbnailPreview
        initPreview={preview}
        onCancel={() => setPreview(null)}
      />
    </>
  )
}

export default ThumbnailList
